export class InteriorThemeConfigurationPropertyType {
    public name: string;
    public properties: string[];

    constructor( name: string, objs: string[] ) {
      this.name = name;
      this.properties = objs;
    }
}
